import { CLIENT_EVENT, EventLogger } from "@app/config/loggers/eventLogger";
import { BottomNav } from "@base/ui/BottomNav";
import { PullToRefreshScrollView } from "@base/ui/PullToRefreshScrollView";
import { useSafeAreaInset } from "@base/ui/SafeArea/useSafeAreaInset";
import { AISummaryCard } from "@features/home/ui/AISummaryCard";
import { NotificationCard } from "@features/home/ui/NotificationCard";
import { ProjectsCard } from "@features/home/ui/ProjectsCard";
import { RecentDailyLogsCard } from "@features/home/ui/RecentDailyLogsCard";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/_authenticated/")({
  component: HomePage,
});

function HomePage() {
  const { bottom } = useSafeAreaInset();

  useEffect(function trackHomeView() {
    EventLogger.view(CLIENT_EVENT.HOME_VIEW);
  }, []);

  return (
    <div className="h-dvh">
      <PullToRefreshScrollView
        // 모바일은 하단 내비 높이만큼 비운다. PC는 하단 내비가 없고 좌우 여백은 shell이 준다.
        className="p-4 pb-[var(--bottom-nav-space)] md:px-0 md:pt-8 md:pb-8"
        style={{ "--bottom-nav-space": `calc(6rem + ${bottom}px)` } as React.CSSProperties}
      >
        <h1 className="text-title5 text-gray-1000 md:mb-1">Welcome!</h1>
        {/* 카드마다 조회 계측이 있어 한 번만 렌더한다. 모바일·PC 모두 한 줄에 하나씩 쌓는다 */}
        <div className="grid grid-cols-1 gap-4 mt-4 md:gap-6 md:mt-6">
          <div className="min-w-0 p-[1px]">
            <NotificationCard />
          </div>
          <div className="min-w-0 p-[1px]">
            <ProjectsCard />
          </div>
          <div className="min-w-0 p-[1px]">
            <AISummaryCard />
          </div>
          <div className="min-w-0 p-[1px]">
            <RecentDailyLogsCard />
          </div>
        </div>
      </PullToRefreshScrollView>

      <BottomNav />
    </div>
  );
}
